/* -------------------------------------------------------------------------- *
 * Sticky Navigation *
 * -------------------------------------------------------------------------- */

let header_el;

const observer_options = {
    rootMargin: '25px',
};

const observer = new IntersectionObserver((entries) => {
    // Check if the element has been scrolled past
    if (entries[0].isIntersecting === false) {
        // Add solid background
        header_el.classList.add('is-scrolled');
    } else {
        // Remove solid background
        header_el.classList.remove('is-scrolled');
    }
}, observer_options);

/* ------------- *
 * Module Export *
 * ------------- */

const StickyNav = {
    init() {
        const sentinel_el = document.querySelector('#js-sentinel');

        header_el = document.querySelector('#js-header');

        // Add a background to the header on scroll
        observer.observe(sentinel_el);
    },
};

export default StickyNav;
